export const ANALYTICS_ENV = {
  LOCAL: 'local',
  STAGING: 'staging',
  PRODUCTION: 'production',
} as const;

export type AnalyticsEnvironment = typeof ANALYTICS_ENV[keyof typeof ANALYTICS_ENV];

/**
 * Detect analytics environment based on hostname.
 * - localhost / 127.0.0.1 → local (console.log only)
 * - *.meitre-test.com → staging (silent, no tracking)
 * - everything else → production (full tracking)
 */
export function getAnalyticsEnvironment(): AnalyticsEnvironment {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return ANALYTICS_ENV.LOCAL;
  }

  if (hostname.endsWith('.meitre-test.com') || hostname === 'meitre-test.com') {
    return ANALYTICS_ENV.STAGING;
  }

  return ANALYTICS_ENV.PRODUCTION;
}
